import React from 'react';
import PropTypes from 'prop-types';
import { compose, branch, renderNothing } from 'recompose';
import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';

import Mobile from './Mobile';
import Desktop from './Desktop';

const CartOverlay = ({ userDevice, ...props }) => {
    if (userDevice !== 'mobile' && userDevice !== 'tablet') {
        return <Desktop {...props} />;
    }

    return <Mobile {...props} isMobile={userDevice === 'mobile'} />;
};

CartOverlay.propTypes = {
    userDevice: PropTypes.string,
};

CartOverlay.defaultProps = {
    userDevice: '',
};

const enhance = compose(
    withDeviceInfo,
    branch(({ cart }) => !cart, renderNothing),
);

export default enhance(CartOverlay);
